import { configureStore } from '@reduxjs/toolkit';
import calendarReducer from './slices/calendarSlice';
import classesReducer from './slices/classesSlice';
import studentsReducer from './slices/studentsSlice';
import authReducer from './slices/authSlice';
import instructorsReducer from './slices/instructorsSlice';
import locationsReducer from './slices/locationsSlice';
import adminUsersReducer from './slices/adminUsersSlice';

export const store = configureStore({
  reducer: {
    calendar: calendarReducer,
    classes: classesReducer,
    students: studentsReducer,
    auth: authReducer,
    instructors: instructorsReducer,
    locations: locationsReducer,
    adminUsers: adminUsersReducer,
  },
});

export default store;

